<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00007">
      CHAPTER V
    </h2>
<p class="calibre3">
      The day after the little conference at John's, Felix had indeed received
      the following note:
    </p>
<p class="calibre3">
      “DEAR FELIX:
    </p>
<p class="calibre3">
      “When you go down to see old Tod, why not put up with us at Becket? Any
      time will suit, and the car can take you over to Joyfields when you like.
      Give the pen a rest. Clara joins in hoping you'll come, and Mother is
      still here. No use, I suppose, to ask Flora.
    </p>
<p class="calibre3">
      “Yours ever,
    </p>
<p class="calibre3">
      “STANLEY.”
     </p>
<p class="calibre3">
      During the twenty years of his brother's sojourn there Felix had been down
      to Becket perhaps once a year, and latterly alone; for Flora, having
      accompanied him the first few times, had taken a firm stand.
    </p>
<p class="calibre3">
      “My dear,” she said, “I feel all body there.”
     </p>
<p class="calibre3">
      Felix had rejoined:
    </p>
<p class="calibre3">
      “No bad thing, once in a way.”
     </p>
<p class="calibre3">
      But Flora had remained firm. Life was too short! She did not get on well
      with Clara. Neither did Felix feel too happy in his sister-in-law's
      presence; but the gray top-hat instinct had kept him going there, for one
      ought to keep in touch with one's brothers.
    </p>
<p class="calibre3">
      He replied to Stanley:
    </p>
<p class="calibre3">
      “DEAR STANLEY:
    </p>
<p class="calibre3">
      “Delighted; if I may bring my two youngsters. We'll arrive to-morrow at
      four-fifty.
    </p>
<p class="calibre3">
      “Yours affectionately,
    </p>
<p class="calibre3">
      “FELIX.”
     </p>
<p class="calibre3">
      Travelling with Nedda was always jolly; one could watch her eyes noting,
      inquiring, and when occasion served, have one's little finger hooked in
      and squeezed. Travelling with Alan was convenient, the young man having a
      way with railways which Felix himself had long despaired of acquiring.
      Neither of the children had ever been at Becket, and though Alan was
      seldom curious, and Nedda too curious about everything to be specially so
      about this, yet Felix experienced in their company the sensations of a new
      adventure.
    </p>
<p class="calibre3">
      Arrived at Transham, that little town upon a hill which the Morton Plough
      Works had created, they were soon in Stanley's car, whirling into the
      sleepy peace of a Worcestershire afternoon. Would this young bird nestling
      up against him echo Flora's verdict: 'I feel all body there!' or would she
      take to its fatted luxury as a duck to water? And he said: “By the way,
      your aunt's 'Bigwigs' set in on a Saturday. Are you for staying and seeing
      the lions feed, or do we cut back?”
     </p>
<p class="calibre3">
      From Alan he got the answer he expected:
    </p>
<p class="calibre3">
      “If there's golf or something, I suppose we can make out all right.” From
      Nedda: “What sort of Bigwigs are they, Dad?”
     </p>
<p class="calibre3">
      “A sort you've never seen, my dear.”
     </p>
<p class="calibre3">
      “Then I should like to stay. Only, about dresses?”
     </p>
<p class="calibre3">
      “What war paint have you?”
     </p>
<p class="calibre3">
      “Only two white evenings. And Mums gave me her Mechlin.”
     </p>
<p class="calibre3">
      “'Twill serve.”
     </p>
<p class="calibre3">
      To Felix, Nedda in white 'evenings' was starry and all that man could
      desire.
    </p>
<p class="calibre3">
      “Only, Dad, do tell me about them, beforehand.”
     </p>
<p class="calibre3">
      “My dear, I will. And God be with you. This is where Becket begins.”
     </p>
<p class="calibre3">
      The car had swerved into a long drive between trees not yet full-grown,
      but decorously trying to look more than their twenty years. To the right,
      about a group of older elms, rooks were in commotion, for Stanley's three
      keepers' wives had just baked their annual rook pies, and the birds were
      not yet happy again. Those elms had stood there when the old Moretons
      walked past them through corn-fields to church of a Sunday. Away on the
      left above the lake, the little walled mound had come in view. Something
      in Felix always stirred at sight of it, and, squeezing Nedda's arm, he
      said:
    </p>
<p class="calibre3">
      “See that silly wall? Behind there Granny's ancients lived. Gone now—new
      house—new lake—new trees—new everything.”
     </p>
<p class="calibre3">
      But he saw from his little daughter's calm eyes that the sentiment in him
      was not in her.
    </p>
<p class="calibre3">
      “I like the lake,” she said. “There's Granny—oh, and a peacock!”
     </p>
<p class="calibre3">
      His mother's embrace, with its frail energy, and the pressure of her soft,
      dry lips, filled Felix always with remorse. Why could he not give the
      simple and direct expression to his feeling that she gave to hers? He
      watched those lips transferred to Nedda, heard her say: “Oh, my darling,
      how lovely to see you! Do you know this for midge-bites?” A hand, diving
      deep into a pocket, returned with a little silver-coated stick having a
      bluish end. Felix saw it rise and hover about Nedda's forehead, and
      descend with two little swift dabs. “It takes them away at once.”
     </p>
<p class="calibre3">
      “Oh, but Granny, they're not midge-bites; they're only from my hat!”
     </p>
<p class="calibre3">
      “It doesn't matter, darling; it takes away anything like that.”
     </p>
<p class="calibre3">
      And he thought: 'Mother is really wonderful!'
    </p>
<p class="calibre3">
      At the house the car had already disgorged their luggage. Only one man,
      but he absolutely the butler, awaited them, and they entered, at once
      conscious of Clara's special pot-pourri. Its fragrance steamed from blue
      china, in every nook and crevice, a sort of baptism into luxury. Clara
      herself, in the outer morning-room, smelled a little of it. Quick and dark
      of eye, capable, comely, perfectly buttoned, one of those women who know
      exactly how not to be superior to the general taste of the period. In
      addition to that great quality she was endowed with a fine nose, an
      instinct for co-ordination not to be excelled, and a genuine love of
      making people comfortable; so that it was no wonder that she had risen in
      the ranks of hostesses, till her house was celebrated for its ease, even
      among those who at their week-ends liked to feel 'all body.' In regard to
      that characteristic of Becket, not even Felix in his ironies had ever
      stood up to Clara; the matter was too delicate. Frances Freeland, indeed—not
      because she had any philosophic preconceptions on the matter, but because
      it was 'not nice, dear, to be wasteful' even if it were only of
      rose-leaves, or to 'have too much decoration,' such as Japanese prints in
      places where they hum—sometimes told her daughter-in-law frankly
      what was wrong, without, however, making the faintest impression upon
      Clara, for she was not sensitive, and, as she said to Stanley, it was
      'only Mother.'
    </p>
<p class="calibre3">
      When they had drunk that special Chinese tea, all the rage, but which no
      one really liked, in the inner morning, or afternoon room—for the
      drawing-rooms were too large to be comfortable except at week-ends—they
      went to see the children, a special blend of Stanley and Clara, save the
      little Francis, who did not seem to be entirely body. Then Clara took them
      to their rooms. She lingered kindly in Nedda's, feeling that the girl
      could not yet feel quite at home, and looking in the soap-dish lest she
      might not have the right verbena, and about the dressing-table to see that
      she had pins and scent, and plenty of 'pot-pourri,' and thinking: 'The
      child is pretty—a nice girl, not like her mother.' Explaining
      carefully how, because of the approaching week-end, she had been obliged
      to put her in 'a very simple room' where she would be compelled to cross
      the corridor to her bath, she asked her if she had a quilted
      dressing-gown, and finding that she had not, left her saying she would
      send one—and could she do her frocks up, or should Sirrett come?
    </p>
<p class="calibre3">
      Abandoned, the girl stood in the middle of the room, so far more 'simple'
      than she had ever slept in, with its warm fragrance of rose-leaves and
      verbena, its Aubusson carpet, white silk-quilted bed, sofa, cushioned
      window-seat, dainty curtains, and little nickel box of biscuits on little
      spindly table. There she stood and sniffed, stretched herself, and
      thought: 'It's jolly—only, it smells too much!' and she went up to
      the pictures, one by one. They seemed to go splendidly with the room, and
      suddenly she felt homesick. Ridiculous, of course! Yet, if she had known
      where her father's room was, she would have run out to it; but her memory
      was too tangled up with stairs and corridors—to find her way down to
      the hall again was all she could have done.
    </p>
<p class="calibre3">
      A maid came in now with a blue silk gown very thick and soft. Could she do
      anything for Miss Freeland? No, thanks, she could not; only, did she know
      where Mr. Freeland's room was?
    </p>
<p class="calibre3">
      “Which Mr. Freeland, miss, the young or the old?”
     </p>
<p class="calibre3">
      “Oh, the old!” Having said which, Nedda felt unhappy; her Dad was not old!
      “No, miss; but I'll find out. It'll be in the walnut wing!” But with a
      little flutter at the thought of thus setting people to run about wings,
      Nedda murmured: “Oh! thanks, no; it doesn't matter.”
     </p>
<p class="calibre3">
      She settled down now on the cushion of the window-seat, to look out and
      take it all in, right away to that line of hills gone blue in the haze of
      the warm evening. That would be Malvern; and there, farther to the south,
      the 'Tods' lived. 'Joyfields!' A pretty name! And it was lovely country
      all round; green and peaceful, with its white, timbered houses and
      cottages. People must be very happy, living here—happy and quiet
      like the stars and the birds; not like the crowds in London thronging
      streets and shops and Hampstead Heath; not like the people in all those
      disgruntled suburbs that led out for miles where London ought to have
      stopped but had not; not like the thousands and thousands of those poor
      creatures in Bethnal Green, where her slum work lay. The natives here must
      surely be happy. Only, were there any natives? She had not seen any. Away
      to the right below her window were the first trees of the fruit garden;
      for many of them Spring was over, but the apple-trees had just come into
      blossom, and the low sun shining through a gap in some far elms was
      slanting on their creamy pink, christening them—Nedda thought—with
      drops of light; and lovely the blackbirds' singing sounded in the perfect
      hush! How wonderful to be a bird, going where you would, and from high up
      in the air seeing everything; flying down a sunbeam, drinking a raindrop,
      sitting on the very top of a tall tree, running in grass so high that you
      were hidden, laying little perfect blue-green eggs, or pure-gray speckly
      ones; never changing your dress, yet always beautiful. Surely the spirit
      of the world was in the birds and the clouds, roaming, floating, and in
      the flowers and trees that never smelled anything but sweet, never looked
      anything but lovely, and were never restless. Why was one restless,
      wanting things that did not come—wanting to feel and know, wanting
      to love, and be loved? And at that thought which had come to her so
      unexpectedly—a thought never before shaped so definitely—Nedda
      planted her arms on the window-sill, with sleeves fallen down, and let her
      hands meet cup-shaped beneath her chin. Love! To have somebody with whom
      she could share everything—some one to whom and for whom she could
      give up—some one she could protect and comfort—some one who
      would bring her peace. Peace, rest—from what? Ah! that she could not
      make clear, even to herself. Love! What would love be like? Her father
      loved her, and she loved him. She loved her mother; and Alan on the whole
      was jolly to her—it was not that. What was it—where was it—when
      would it come and wake her, and kiss her to sleep, all in one? Come and
      fill her as with the warmth and color, the freshness, light, and shadow of
      this beautiful May evening, flood her as with the singing of those birds,
      and the warm light sunning the apple blossoms. And she sighed. Then—as
      with all young things whose attention after all is but as the hovering of
      a butterfly—her speculation was attracted to a thin, high-shouldered
      figure limping on a stick, away from the house, down one of the paths
      among the apple-trees. He wavered, not knowing, it seemed, his way. And
      Nedda thought: 'Poor old man, how lame he is!' She saw him stoop,
      screened, as he evidently thought, from sight, and take something very
      small from his pocket. He gazed, rubbed it, put it back; what it was she
      could not see. Then pressing his hand down, he smoothed and stretched his
      leg. His eyes seemed closed. So a stone man might have stood! Till very
      slowly he limped on, passing out of sight. And turning from the window,
      Nedda began hurrying into her evening things.
    </p>
<p class="calibre3">
      When she was ready she took a long time to decide whether to wear her
      mother's lace or keep it for the Bigwigs. But it was so nice and creamy
      that she simply could not take it off, and stood turning and turning
      before the glass. To stand before a glass was silly and old-fashioned; but
      Nedda could never help it, wanting so badly to be nicer to look at than
      she was, because of that something that some day was coming!
    </p>
<p class="calibre3">
      She was, in fact, pretty, but not merely pretty—there was in her
      face something alive and sweet, something clear and swift. She had still
      that way of a child raising its eyes very quickly and looking straight at
      you with an eager innocence that hides everything by its very wonder; and
      when those eyes looked down they seemed closed—their dark lashes
      were so long. Her eyebrows were wide apart, arching with a slight angle,
      and slanting a little down toward her nose. Her forehead under its
      burnt-brown hair was candid; her firm little chin just dimpled.
      Altogether, a face difficult to take one's eyes off. But Nedda was far
      from vain, and her face seemed to her too short and broad, her eyes too
      dark and indeterminate, neither gray nor brown. The straightness of her
      nose was certainly comforting, but it, too, was short. Being creamy in the
      throat and browning easily, she would have liked to be marble-white, with
      blue dreamy eyes and fair hair, or else like a Madonna. And was she tall
      enough? Only five foot five. And her arms were too thin. The only things
      that gave her perfect satisfaction were her legs, which, of course, she
      could not at the moment see; they really WERE rather jolly! Then, in a
      panic, fearing to be late, she turned and ran out, fluttering into the
      maze of stairs and corridors.
    </p>
<p class="calibre3">
<a id="link2HCH0006">
</a>
</p>
<div class="pg-boilerplate" id="calibre_pb_3"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?ebbf5490